export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SO-dc2a3eaf32309c94886b2af65a09ca51.png";